import {ActivityIndicator, ActivityIndicatorProps} from 'react-native';
import {withTheme} from '@rneui/themed';

export default withTheme(ActivityIndicator, 'ActivityIndicator');

declare module '@rneui/themed' {
  export interface ComponentTheme {
    ActivityIndicator: Partial<ActivityIndicatorProps>;
  }
}
